import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AuthService } from "src/app/services/auth.service";
import { CatComponentService } from "src/app/services/cat-component.service";
import { VersionService } from "src/app/services/version.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit, OnDestroy {
  public viewMenu: any[] = [];
  public menu: any[] = [];
  // public catMenu: CatComponent[] = [];
  public toggled: boolean = false;
  public openSubmenuKey: string | null = null;
  public versionFront: string = environment.version;
  public versionBack: string = 'Cargando...'; // Mostrar "Cargando..." mientras se obtiene
  private destroy$ = new Subject<void>();
  /////////////////
  constructor(private router: Router,
    private auth: AuthService,
    private catComponentService: CatComponentService,
    public versionService: VersionService) { }

  ngOnInit() {
    // Obtener versión del backend
    this.versionBack = this.versionService.getVersion() || 'X.X.X';

    // Suscribirse al observable de versión (solo emite cuando hay un valor real)
    this.versionService.version$
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        version => {
          this.versionBack = version;
          console.log('Versión del backend actualizada:', version);
        },
        error => {
          console.error('Error en suscripción de versión:', error);
          this.versionBack = 'X.X.X';
        }
      );
    //We need to create a service to get the menu from API
    // Getting Menu from API
    this.catComponentService.getComponents().subscribe((catComponents: any) => {
      // Applying role filter
      this.viewMenu = this.getMenu(catComponents.data.filter((c: any) => c.componentType === 'functionsMenu'));
      this.menu = this.getMenu(catComponents.data.filter((c: any) => c.componentType === 'configMenu'));
    });
    //Aplicar Filtro por Roles
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Aplicar Filtro por Roles
  private getMenu(menu: any[]) {
    const userRoles = this.auth.getUserRoles(); // ej: ['USER']
    console.log('User Roles:', userRoles);
    console.log('Menu before filter:', menu);

    return menu.filter(item => {
      // si roles está vacío o no existe, no mostrar
      if (!item.roles || item.roles.length === 0) return false;

      // Validate if roles exist in componentChild (solo si existe)
      if (item.componentChild && Array.isArray(item.componentChild)) {
        item.componentChild = item.componentChild.filter(child => {
          if (!child.roles || child.roles.length === 0) return false;
          return child.roles.some(role => userRoles.includes(role));
        });
      }

      // mostrar solo si hay intersección entre roles del usuario y roles del menú
      const hasRole = item.roles.some(role => userRoles.includes(role));
      console.log(`Item ${item.componentName}: hasRole=${hasRole}, roles=${item.roles}`);
      return hasRole;
    });
  }

  goTo = (e, path) => {
    if (e) e.preventDefault();
    this.router.navigateByUrl(path);
  };

  toggleBar = (e) => {
    if (e) e.preventDefault();
    this.toggled = !this.toggled;
    if (this.toggled) {
      this.openSubmenuKey = null;
    }
  };

  toggleSubmenu = (e, group: string, componentId: string | number) => {
    if (e) e.preventDefault();
    if (this.toggled) {
      this.toggled = false;
    }

    const key = `${group}-${componentId}`;
    this.openSubmenuKey = this.openSubmenuKey === key ? null : key;
  };

  isSubmenuOpen = (group: string, componentId: string | number) => {
    return this.openSubmenuKey === `${group}-${componentId}`;
  };

}
